module.exports = __webpack_public_path__ + "static/media/ic_random.070d643e.svg";